import { RecommendationsTab } from './RecommendationsTab'

/**
 * SP4: visão filtrada da tabela unificada de recomendações
 * (rec_type ∈ {savings_plans, ri}). Substitui o stub de projeções estáticas.
 */
export function SavingsPlansTab() {
  return <RecommendationsTab recTypes={['savings_plans', 'ri']} />
}